// configure typography here
const textStyles = {
  h1: {},
  h2: {},
};

export default textStyles;
